// Generated by purs version 0.13.8
"use strict";
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Class_Console = require("../Effect.Class.Console/index.js");
var printString = function (dictMonadEffect) {
    var $3 = Effect_Class.liftEffect(dictMonadEffect);
    var $4 = Effect_Class_Console.log(Effect_Class.monadEffectEffect);
    return function ($5) {
        return $3($4($5));
    };
};
var print = function (dictMonadEffect) {
    return function (dictShow) {
        var $6 = Effect_Class.liftEffect(dictMonadEffect);
        var $7 = Effect_Class_Console.logShow(Effect_Class.monadEffectEffect)(dictShow);
        return function ($8) {
            return $6($7($8));
        };
    };
};
module.exports = {
    print: print,
    printString: printString
};
